module.exports = __webpack_public_path__ + "fonts/Barlow-Light.37aa897d.woff";